// 1. Ant Design
import { BankOutlined, CarOutlined, DollarOutlined, FileTextOutlined, HomeOutlined, TeamOutlined, ThunderboltOutlined, UserOutlined, } from "@ant-design/icons";
// 5. Types, utils, styles
import { B2B_ENABLED } from "@/utils/featureFlags";
import { hasPermission } from "@/utils/permissions";
import { Permission } from "@/types/employe/employee.common";
/**
 * Единый источник прав для маршрутов персонала: используется и меню, и AppRouter (ProtectedRoute).
 */
export const STAFF_ROUTE_PERMISSIONS = {
    users: Permission.USERS_MANAGE,
    tariffsRead: Permission.DICTIONARIES_READ,
    tariffsCreate: Permission.SYSTEM_SETTINGS,
    companies: Permission.COMPANIES_READ,
    /** FR-006: создание компании — обе роли персонала. */
    companiesCreate: Permission.COMPANIES_WRITE,
    /** FR-006: вкладка «Взаиморасчёты» карточки компании — только ADMINISTRATOR (D14). */
    companySettlements: Permission.SETTLEMENTS_READ,
};
export const STAFF_MENU = [
    {
        key: "/",
        label: "Дашбоард",
        icon: HomeOutlined,
    },
    {
        key: "orders-routes",
        label: "Заказы и маршруты",
        icon: FileTextOutlined,
        children: [
            { key: "/quick-orders", label: "Заказы без маршрутов" },
            { key: "/orders", label: "Все заказы" },
            { key: "/routes", label: "Все маршруты" },
        ],
    },
    {
        key: "technicians-bases",
        label: "Техники, Совы, Базы",
        icon: TeamOutlined,
        children: [
            { key: "/workshifts", label: "Смены" },
            { key: "/technicians", label: "Все техники" },
            { key: "/bases", label: "Базы" },
            { key: "/service-vehicles", label: "Совы" },
        ],
    },
    {
        key: "charging-stations-group",
        label: "Зарядные станции",
        icon: ThunderboltOutlined,
        children: [
            { key: "/charging-stations", label: "Список станций" },
            { key: "/manufacturers", label: "Производители станций" },
            { key: "/charging-station-models", label: "Модели станций" },
        ],
    },
    {
        key: "vehicles-catalog",
        label: "Справочник автомобилей",
        icon: CarOutlined,
        children: [
            { key: "/vehicle-models", label: "Справочник моделей авто" },
            { key: "/vehicle-manufacturers", label: "Справочник производителей" },
        ],
    },
    {
        key: "/tariffs",
        label: "Тарифы",
        icon: DollarOutlined,
        permission: STAFF_ROUTE_PERMISSIONS.tariffsRead,
    },
    {
        key: "/companies",
        label: "Корпоративные клиенты",
        icon: BankOutlined,
        permission: STAFF_ROUTE_PERMISSIONS.companies,
        requiresB2B: true,
        testId: "corp-menu-companies",
    },
    {
        key: "/users",
        label: "Управление пользователями",
        icon: UserOutlined,
        permission: STAFF_ROUTE_PERMISSIONS.users,
    },
];
/**
 * Фильтрует пункты меню по Permission роли и флагу сборки B2B.
 * Группа без видимых детей скрывается.
 */
export const filterStaffMenu = (items, userRole, b2bEnabled = B2B_ENABLED) => {
    return items.reduce((acc, item) => {
        if (item.permission && !hasPermission(userRole, item.permission)) {
            return acc;
        }
        if (item.requiresB2B && !b2bEnabled) {
            return acc;
        }
        if (item.children) {
            const children = filterStaffMenu(item.children, userRole, b2bEnabled);
            if (children.length === 0) {
                return acc;
            }
            acc.push({ ...item, children });
            return acc;
        }
        acc.push(item);
        return acc;
    }, []);
};
const buildParentByPath = (items) => {
    return items.reduce((acc, item) => {
        if (item.children) {
            item.children.forEach((child) => {
                acc[child.key] = item.key;
            });
        }
        return acc;
    }, {});
};
export const STAFF_MENU_PARENT_BY_PATH = buildParentByPath(STAFF_MENU);
